/**
 * Legacy IANA names some browsers still report, mapped to their current names:
 * North American links, common links abroad, and the UTC aliases. Glepnir
 * validates booking timezones against PHP's current list, which leaves these
 * out, so a booking sent with one of them fails.
 */
export const legacyTimezoneAliases: Record<string, string> = {
  "US/Alaska": "America/Anchorage",
  "US/Aleutian": "America/Adak",
  "US/Arizona": "America/Phoenix",
  "US/Central": "America/Chicago",
  "US/East-Indiana": "America/Indiana/Indianapolis",
  "US/Eastern": "America/New_York",
  "US/Hawaii": "Pacific/Honolulu",
  "US/Indiana-Starke": "America/Indiana/Knox",
  "US/Michigan": "America/Detroit",
  "US/Mountain": "America/Denver",
  "US/Pacific": "America/Los_Angeles",
  "US/Samoa": "Pacific/Pago_Pago",
  "America/Fort_Wayne": "America/Indiana/Indianapolis",
  "America/Indianapolis": "America/Indiana/Indianapolis",
  "America/Knox_IN": "America/Indiana/Knox",
  "America/Louisville": "America/Kentucky/Louisville",
  "Canada/Atlantic": "America/Halifax",
  "Canada/Central": "America/Winnipeg",
  "Canada/Eastern": "America/Toronto",
  "Canada/Mountain": "America/Edmonton",
  "Canada/Newfoundland": "America/St_Johns",
  "Canada/Pacific": "America/Vancouver",
  "Canada/Saskatchewan": "America/Regina",
  "Canada/Yukon": "America/Whitehorse",
  "Mexico/BajaNorte": "America/Tijuana",
  "Mexico/BajaSur": "America/Mazatlan",
  "Mexico/General": "America/Mexico_City",
  Navajo: "America/Denver",
  "America/Coral_Harbour": "America/Atikokan",
  "America/Buenos_Aires": "America/Argentina/Buenos_Aires",
  "America/Catamarca": "America/Argentina/Catamarca",
  "America/Cordoba": "America/Argentina/Cordoba",
  "America/Godthab": "America/Nuuk",
  "America/Jujuy": "America/Argentina/Jujuy",
  "America/Mendoza": "America/Argentina/Mendoza",
  "Brazil/East": "America/Sao_Paulo",
  "Chile/Continental": "America/Santiago",
  Cuba: "America/Havana",
  Jamaica: "America/Jamaica",
  "Africa/Asmera": "Africa/Asmara",
  Egypt: "Africa/Cairo",
  "Atlantic/Faeroe": "Atlantic/Faroe",
  Eire: "Europe/Dublin",
  "Europe/Belfast": "Europe/London",
  "Europe/Kiev": "Europe/Kyiv",
  "Europe/Uzhgorod": "Europe/Kyiv",
  "Europe/Zaporozhye": "Europe/Kyiv",
  GB: "Europe/London",
  Poland: "Europe/Warsaw",
  Portugal: "Europe/Lisbon",
  Turkey: "Europe/Istanbul",
  "Asia/Calcutta": "Asia/Kolkata",
  "Asia/Dacca": "Asia/Dhaka",
  "Asia/Istanbul": "Europe/Istanbul",
  "Asia/Katmandu": "Asia/Kathmandu",
  "Asia/Macao": "Asia/Macau",
  "Asia/Rangoon": "Asia/Yangon",
  "Asia/Saigon": "Asia/Ho_Chi_Minh",
  "Asia/Tel_Aviv": "Asia/Jerusalem",
  "Asia/Thimbu": "Asia/Thimphu",
  "Asia/Ujung_Pandang": "Asia/Makassar",
  "Asia/Ulan_Bator": "Asia/Ulaanbaatar",
  Hongkong: "Asia/Hong_Kong",
  Iran: "Asia/Tehran",
  Israel: "Asia/Jerusalem",
  Japan: "Asia/Tokyo",
  PRC: "Asia/Shanghai",
  ROK: "Asia/Seoul",
  Singapore: "Asia/Singapore",
  "Australia/ACT": "Australia/Sydney",
  "Australia/NSW": "Australia/Sydney",
  NZ: "Pacific/Auckland",
  "Pacific/Enderbury": "Pacific/Kanton",
  "Pacific/Ponape": "Pacific/Pohnpei",
  "Pacific/Truk": "Pacific/Chuuk",
  "Etc/GMT": "UTC",
  "Etc/Greenwich": "UTC",
  "Etc/UCT": "UTC",
  "Etc/Universal": "UTC",
  "Etc/UTC": "UTC",
  "Etc/Zulu": "UTC",
  GMT: "UTC",
  Greenwich: "UTC",
  UCT: "UTC",
  Universal: "UTC",
  Zulu: "UTC",
};
